import { FC } from 'react';
import styles from './BackConfirmationModal.module.scss';
import Modal from 'components/Modal/Modal';
import DentalButton from 'components/Buttons/DentalButton/DentalButton';

interface BackConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const BackConfirmationModal: FC<BackConfirmationModalProps> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      isCloseIconDisplayed={false}
      isNotFullScreen
      customStyle={styles['modal']}
    >
      <div className={styles['container']}>
        <h3 className={styles['title']}>Leave this page</h3>
        <span className={styles['info']}>
          Are you sure you want to go back to the previous step? All the
          appointments you have selected will be deselected
        </span>

        <div className={styles['btn-group']}>
          <DentalButton
            variant="outlined"
            className={styles['btn']}
            onClick={onCancel}
          >
            Cancel
          </DentalButton>

          <DentalButton
            variant="contained"
            className={styles['btn']}
            onClick={onConfirm}
          >
            Yes, go back
          </DentalButton>
        </div>
      </div>
    </Modal>
  );
};

export default BackConfirmationModal;
